// extracted by mini-css-extract-plugin
module.exports = {"wrapperBody":"ModalDocumentScan_wrapperBody__11iys","wrapperTitle":"ModalDocumentScan_wrapperTitle__1QU2R"};